module.exports = __webpack_public_path__ + "img/bg6.db85847f.jpg";